import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Right from '../../right/Right';
import './MealPlanner.css';
import FooterMenu from "./common/FooterMenu";
import Cookies from "js-cookie";
import { fetchInitialData5 } from "../../fetchData";
import Service from '../../service/Service';
import * as actions from './actions';
import withContext from "../../../withContext";

const service = new Service();

class Recipedetails extends Component {
    constructor(props) {
        console.log("::::::Recipedetails props::::::", props);
        let serverSideData = {};
        let initialData = [];
        let recipeDetailData = [];
        let ingreDients = [];
        let nutrionalFacts = [];
        let preparedArr = [];
        let secondReciepId = [];
        let reviewDataDetails = [];
        let reviewDetails = [];
        let ingredientsArr = [];
        let ratingDetails = [];
        let nutriFactColors = {};
        let ratingAllDetails = [];
        let setViewDetails = [];
        let metaTitle = '';
        let metaDescription = '';
        let recipeName = [];
        let isApp = '';
        super(props);

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            console.log("✅ Initial data found in window.__initialData__");
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            console.log("Trying to get data from props.staticContext...");
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
                console.log("✅ Found initialData from staticContext");
            } else {
                console.log("❌ No initialData found in both window and staticContext");
            }
        }
        
        if (serverSideData) {
            console.log("🔍 serverSideData keys:", Object.keys(serverSideData));
        
            // Data1
            if (serverSideData['data1'] && serverSideData['data1']['msg'] == 1 && serverSideData['data1']['result'] && serverSideData['data1']['result'][0]) {
                console.log("✅ Found data1 result:", serverSideData['data1']['result'][0]);
        
                if (serverSideData['data1']['result'][0].firstrec && serverSideData['data1']['result'][0].secondrec) {
                    console.log("📦 Handling data1 -> firstrec and secondrec case");
                    if (
                        serverSideData['data1']['result'][0].firstrec.nutrionalFacts &&
                        serverSideData['data1']['result'][0].firstrec.nutrionalFactsColors &&
                        serverSideData['data1']['result'][0].firstrec.preparedArr
                    ) {
                        console.log("✅ Valid firstrec structure");
                        initialData = serverSideData['data1'];
                        recipeDetailData = serverSideData['data1']['result'][0].firstrec;
                        nutrionalFacts = recipeDetailData.nutrionalFacts;
                        nutriFactColors = recipeDetailData.nutrionalFactsColors;
                        preparedArr = recipeDetailData.preparedArr;
                        console.log("recipeDetailData:", recipeDetailData);
                    } else {
                        console.warn("⚠️ Missing nutrionalFacts or preparedArr in firstrec");
                    }
        
                    if (serverSideData['data1']['result'][0].secondrec) {
                        secondReciepId = serverSideData['data1']['result'][0].secondrec;
                        console.log("secondReciepId:", secondReciepId);
                    }
                } else {
                    console.log("📦 Handling single recipe case (no secondrec)");
                    if (serverSideData['data1']['result'][0].nutrionalFacts && serverSideData['data1']['result'][0].preparedArr) {
                        initialData = serverSideData['data1'];
                        recipeDetailData = serverSideData['data1']['result'][0];
                        nutrionalFacts = recipeDetailData.nutrionalFacts;
                        preparedArr = recipeDetailData.preparedArr;
                        console.log("Single recipeDetailData:", recipeDetailData);
                    } else {
                        console.warn("⚠️ Missing nutrionalFacts or preparedArr in single recipe case");
                    }
        
                    if (serverSideData['data1']['result'][0].nutrionalFactsColors) {
                        nutriFactColors = serverSideData['data1']['result'][0].nutrionalFactsColors;
                        console.log("nutriFactColors:", nutriFactColors);
                    }
                }
            } else {
                console.warn("❌ Invalid or missing data1 structure");
            }
        
            // Data2
            if (serverSideData['data2'] && serverSideData['data2']['msg'] == 1 && serverSideData['data2']['result'] && serverSideData['data2']['result'][0] && serverSideData['data2']['result'][0]['ingredientsArr']) {
                console.log("✅ Found data2 with ingredients");
                ingreDients = serverSideData['data2']['result'][0];
                ingredientsArr = ingreDients['ingredientsArr'];
                console.log("ingredientsArr:", ingredientsArr);
            } else {
                console.warn("⚠️ data2 missing or invalid");
            }
        
            // Data3
            if (serverSideData['data3'] && serverSideData['data3']['msg'] == 1 && serverSideData['data3']['result']) {
                console.log("✅ Found data3 (reviews)");
                reviewDataDetails = serverSideData['data3']['result'];
                reviewDetails = serverSideData['data3'];
                console.log("reviewDataDetails:", reviewDataDetails);
            } else {
                console.warn("⚠️ data3 missing or invalid");
            }
        
            // Data4
            if (serverSideData['data4'] && serverSideData['data4']['msg'] == 1 && serverSideData['data4']['result'] && serverSideData['data4']['result'][0]) {
                console.log("✅ Found data4 (ratings)");
                ratingDetails = serverSideData['data4']['result'][0];
                ratingAllDetails = serverSideData['data4'];
                console.log("ratingDetails:", ratingDetails);
            } else {
                console.warn("⚠️ data4 missing or invalid");
            }
        
            // Data5
            if (serverSideData['data5'] && serverSideData['data5']['msg'] == 1 && serverSideData['data5']['result']) {
                console.log("✅ Found data5 (view details)");
                setViewDetails = serverSideData['data5'];
                console.log("setViewDetails:", setViewDetails);
            } else {
                console.warn("⚠️ data5 missing or invalid");
            }
        } else {
            console.error("❌ serverSideData is undefined or empty");
        }
        


        // if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
        //     serverSideData = window.__initialData__['initialData'];
        //     delete window.__initialData__;
        // } else {
        //     if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
        //         serverSideData = props.staticContext.initialData['initialData'];
        //     }
        // }
        // if (serverSideData) {
        //     if (serverSideData['data1'] && serverSideData['data1']['msg'] == 1 && serverSideData['data1']['result'] && serverSideData['data1']['result'][0] && serverSideData['data1']['result'][0].firstrec && serverSideData['data1']['result'][0].secondrec) {
        //         if (serverSideData['data1']['result'][0].firstrec.nutrionalFacts && serverSideData['data1']['result'][0].firstrec.nutrionalFactsColors && serverSideData['data1']['result'][0].firstrec.preparedArr) {
        //             initialData = serverSideData['data1'];
        //             recipeDetailData = serverSideData['data1']['result'][0].firstrec;
        //             nutrionalFacts = serverSideData['data1']['result'][0].firstrec.nutrionalFacts;
        //             nutriFactColors = serverSideData['data1']['result'][0].firstrec.nutrionalFactsColors;
        //             preparedArr = serverSideData['data1']['result'][0].firstrec.preparedArr;
        //         }
        //         if (serverSideData['data1']['result'][0].secondrec) {
        //             secondReciepId = serverSideData['data1']['result'][0].secondrec;
        //         }
        //     } else if (serverSideData['data1'] && serverSideData['data1']['msg'] == 1 && serverSideData['data1']['result'] && serverSideData['data1']['result'][0]) {
        //         if (serverSideData['data1']['result'][0].nutrionalFacts && serverSideData['data1']['result'][0].preparedArr) {
        //             initialData = serverSideData['data1'];
        //             recipeDetailData = serverSideData['data1']['result'][0];
        //             nutrionalFacts = serverSideData['data1']['result'][0].nutrionalFacts;
        //             preparedArr = serverSideData['data1']['result'][0].preparedArr;
        //         }
        //         if (serverSideData['data1']['result'][0].nutrionalFactsColors) {
        //             nutriFactColors = serverSideData['data1']['result'][0].nutrionalFactsColors;
        //         }
        //     }

        //     if (serverSideData['data2'] && serverSideData['data2']['msg'] == 1 && serverSideData['data2']['result'] && serverSideData['data2']['result'][0] && serverSideData['data2']['result'][0]['ingredientsArr']) {
        //         ingreDients = serverSideData['data2']['result'][0];
        //         ingredientsArr = serverSideData['data2']['result'][0]['ingredientsArr'];
        //     }
        //     if (serverSideData['data3'] && serverSideData['data3']['msg'] == 1 && serverSideData['data3']['result'] && serverSideData['data3']['result']) {
        //         reviewDataDetails = serverSideData['data3']['result'];
        //         reviewDetails = serverSideData['data3'];
        //     }
        //     if (serverSideData['data4']['msg'] == 1 && serverSideData['data4']['result'] && serverSideData['data4']['result']) {
        //         ratingDetails = serverSideData['data4']['result'][0];
        //         ratingAllDetails = serverSideData['data4'];
        //     }
        //     if (serverSideData['data5'] && serverSideData['data5']['msg'] == 1 && serverSideData['data5']['result']) {
        //         setViewDetails = serverSideData['data5'];
        //     }
        // }


        var urlParam = (props.location.pathname + props.location.search);
        console.log("👉 Full URL param (pathname + search):", urlParam);
        console.log("👉 Server side data:", serverSideData);
            
        if (urlParam.split("/")[3]) {
            console.log("👉 urlParam.split('/')[3]:", urlParam.split("/")[3]);
        
            var hostUrl = urlParam.split("/")[3].split("?");
            console.log("👉 hostUrl after split('?'):", hostUrl);
        
            recipeName = hostUrl[0].replace(/-/g, " ");
            console.log("👉 recipeName after replacing '-' with space:", recipeName);
        
            recipeName = recipeName && recipeName.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
            console.log("👉 recipeName after capitalizing:", recipeName);
        
            metaTitle = "How to Make " + recipeName + " for Babies & Toddlers - Baby Meal Planner";
            console.log("👉 metaTitle:", metaTitle);
        
            metaDescription = [
                { "name": "description", "content": "Learn how to make a " + recipeName + ". This baby meal planner provides you with an easy and simple recipe to prepare a nutritious wheat porridge for your child. " },
                { "name": "keywords", "content": recipeName + " recipe, how to make a " + recipeName + " for baby" },
                { "name": "atdlayout", "content": "" },
                { "name": "robots", "content": "noindex, nofollw" }
            ];
            console.log("👉 metaDescription:", metaDescription);
        }
        


        if (this.props.location.search.includes('from=app')) {
            isApp = true;
        }


        var recId = "";
        var mealId = "";
        if (__isBrowser__) {
            var hostUrl = window.location.href;
            if (hostUrl.split("/")[5]) {
                var idObj = hostUrl.split("/")[5];
                if (idObj.split("?recId=").length > 1 || idObj.split("&recId=").length > 1 || idObj.split("?meal=").length > 1) {
                    var check = idObj.split("?recId=").length > 1 ? idObj.split("?recId=") : idObj.split("&recId=");
                    recId = check && check[1];
                }
                if (idObj.split("?meal=").length > 1) {
                    var check = idObj.split("?meal=")[1].split("&recId");
                    mealId = check && check[0];
                }
                if (recId && recId.includes('#')) {
                    recId = recId.split('#')[0];
                }
                if (recId && recId.includes('&')) {
                    recId = recId.split('&')[0];
                }
            }
        }



        this.state = {
            recipeDetailData: recipeDetailData,
            initialData: initialData,
            ingreDients: ingreDients,
            nutrionalFacts: nutrionalFacts,
            nutriFactColors: nutriFactColors,
            preparedArr: preparedArr,
            ingredientsArr: ingredientsArr,
            secondReciepId: secondReciepId,
            reviewDataDetails: reviewDataDetails,
            reviewDetails: reviewDetails,
            ratingDetails: ratingDetails,
            ratingAllDetails: ratingAllDetails,
            setViewDetails: setViewDetails,
            nutriFactsColorArr: '',
            childPhoto: Cookies.get("childPhoto"),
            recipeId: '',
            rateCount: '',
            nutrionalItems: '',
            textValue: '',
            babyAge: '',
            text_max: 30,
            chars_left: 30,
            textValue1: '',
            text_max1: 200,
            starRate: [],
            chars_left1: 200,
            tncAgree: false,
            cookTime: '',
            prepTime: '',
            totalTime: '',
            metaTitle: metaTitle,
            metaDescription: metaDescription,
            recipeName: recipeName,
            recipePhoto: "rePh_" + recId,
            scrollCountGA: '1',
            isApp: isApp,
            recipeId: recId,
            mealId: mealId,
            urlpath : (props.location.pathname + props.location.search)
        };
        this.isChatJsLoaded = false;
        this.qnaPageNo = 1;
        this.maxScroll = 0;
        this.totalCount = this.state.reviewDetails.userUploadedImgCount;
        if (this.props.params.page && this.props.params.page > 0) {
            this.qnaPageNo = parseInt(this.props.params.page);
        }
        console.log("this.state 👉👉👉👉👉👉👉👉", this.state)
    }
    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData) {
        console.log("authData---", authData);

        console.log("cookieData---", cookieData);
        let LatestFtk = '';
        if (cookieData && (cookieData.includes("app_ftk"))) {
            var cookieAry = cookieData.split(';');
            for (var i = 0; i < cookieAry.length; i++) {
                if (cookieAry[i] && cookieAry[i].includes("app_ftk")) {
                    LatestFtk = cookieAry[i].split('app_ftk=')[1];
                }
            }
        }
        console.log("LatestFtk=====>", LatestFtk);



        let obj1, idObj;
        var _recipeId;
        var _mealiD = '';
        // if (cookieData && (cookieData.includes("resipeId") || cookieData.includes("RecipeList") || cookieData.includes("mealId"))) {
        //     var cookieAry = cookieData.split(';');
        //     for (var i = 0; i < cookieAry.length; i++) {
        //         // if (cookieAry[i] && cookieAry[i].includes("resipeId")) {
        //         //     _recipeId = cookieAry[i].split('resipeId=')[1];
        //         // }
        //         if (cookieAry[i] && cookieAry[i].includes("RecipeList")) {
        //             var _reciFlag = cookieAry[i].split('RecipeList=')[1];
        //         }
        //         if (cookieAry[i] && cookieAry[i].includes("mealId")) {
        //             var _mealiD = cookieAry[i].split('mealId=')[1];
        //         }

        //     }

        // }

        var RecipeDetailsUrl = reqUrl.split("/")[3];

        console.log("RecipeDetailsUrl==============> =", reqUrl.split("/"));

        // if (RecipeDetailsUrl.split("?recId=").length > 1 || RecipeDetailsUrl[3].split("&recId=").length > 1 ) {
        //     idObj = RecipeDetailsUrl.split("?recId=") ? RecipeDetailsUrl.split("?recId=") : RecipeDetailsUrl.split("&recId=");
        //     var check = idObj[1];
        //     _recipeId = check;
        // } else {
        //     if (RecipeDetailsUrl.split("?")) {
        //         idObj = RecipeDetailsUrl.split("?");
        //         var check = idObj[1];
        //         _recipeId = check;
        //     }
        // }
        // if (_recipeId.includes('#')) {
        //     _recipeId = _recipeId.split('#')[0];
        // }
        // if (_recipeId.includes('&')) {
        //     _recipeId = _recipeId.split('&')[0];
        // }

        if (RecipeDetailsUrl.split("?recId=").length > 1 || RecipeDetailsUrl.split("&recId=").length > 1) {
            idObj = RecipeDetailsUrl.split("?recId=").length > 1 ? RecipeDetailsUrl.split("?recId=") : RecipeDetailsUrl.split("&recId=");
            var check = idObj && idObj[1];
            _recipeId = check;
        }
        if (RecipeDetailsUrl.split("?meal=").length > 1) {
            if (RecipeDetailsUrl.split("?meal=")) {
                idObj = RecipeDetailsUrl.split("?meal=")[1].split("&recId");
                var check = idObj && idObj[0];
                _mealiD = check;
            }
        }
        console.log("idObj==============>", idObj);

        if (_recipeId && _recipeId.includes('#')) {
            _recipeId = _recipeId.split('#')[0];
        }
        if (_recipeId && _recipeId.includes('&')) {
            _recipeId = _recipeId.split('&')[0];
        }
        console.log("_reciFlag,_mealiD==============>", _recipeId, _mealiD, RecipeDetailsUrl);
        var header = {
            'Content-Type': 'application/json',
            'ftk': (ftk != "") ? ftk : LatestFtk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }

        console.log("Recipedetails Details api header: ", header);
        // 6mealId7a9c58281
        //
        console.log("true==============>", !RecipeDetailsUrl.split("?recId").length > 1);

        console.log("_mealiD=======:::=======>", _mealiD);
        console.log("_recipeId========:::======>", _recipeId);

       
        if (_mealiD != '') {
            obj1 = {
                url: global.api_url + "dietplan/getreceipemealdetailsPage",
                body: JSON.stringify({ "mealid": _mealiD })
            };
        } else {
            obj1 = {
                url: global.api_url + "dietplan/getreceipeDetails",
                body: JSON.stringify({ "recipeid": _recipeId })
            };
        }
        let obj2 = {
            url: global.api_url + "dietplan/getreceingredients",
            body: JSON.stringify({ "recipeid": _recipeId })
        };

        let obj3 = {
            url: global.api_url + "dietplan/getreviewdetails",
            body: JSON.stringify({
                "recipeid": _recipeId,
                "pageno": "1",
                "pagesize": "10"
            })
        };
        let obj4 = {
            url: global.api_url + "dietplan/getratingdetail",
            body: JSON.stringify({
                "recipeid": _recipeId
            })
        };
        let obj5 = {
            url: global.api_url + "dietplan/setrecuserview",
            body: JSON.stringify({
                "recipeid": _recipeId
            })
        };

        console.log("Recipedetails api 1 from component: ",obj1);
        console.log("Recipedetails api 2 from component: ",obj2);
        console.log("Recipedetails api 3 from component: ",obj3);
        console.log("Recipedetails api 4 from component: ",obj4);
        console.log("Recipedetails api 5 from component: ",obj5);


        return fetchInitialData5(obj1, obj2, obj3, obj4,obj5, JSON.stringify(header));

    }
    componentDidMount() {
        // if (window.__AUTH_DATA__?.authData?.ftk &&  (!global.ftk || global.ftk === 'undefined')) {
        //             global.ftk = window.__AUTH_DATA__?.authData?.ftk;
        //           } else {
        //             if (window.__AUTH_DATA__?.authData?.app_ftk != "") {
        //               global.ftk = Cookies.get("app_ftk");
        //             } else {
        //               global.ftk = Cookies.get("app_ftk");
        //               if (typeof global.ftk == "undefined") {
        //                 global.ftk = "";
        //               }
        //             }
        //           }

        let recipeName ;

        // var urlParam = this.state.urlpath;
        var urlParam = typeof window !== "undefined" ? this.state.urlpath : window.location.href ;

        console.log("#👉 Full URL param (pathname + search):", urlParam);
            
        if (urlParam.split("/")[3]) {
            console.log("#👉 urlParam.split('/')[3]:", urlParam.split("/")[3]);
        
            var hostUrl = urlParam.split("/")[3].split("?");
            console.log("#👉 hostUrl after split('?'):", hostUrl);
        
            recipeName = hostUrl[0].replace(/-/g, " ");
            console.log("#👉 recipeName after replacing '-' with space:", recipeName);
        
            recipeName = recipeName && recipeName.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
            console.log("#👉 recipeName after capitalizing:", recipeName);
        
            this.setState({ recipeName: recipeName });
            console.log("state value :", this.state.recipeName)

        }
        
        console.log("secondReciepId=============>", this.state.secondReciepId);
        console.log("recipeDetailData=============>", this.state.recipeDetailData);
        console.log("ingreDients=============>", this.state.ingreDients);
        console.log("preparedArr=============>", this.state.preparedArr);
        console.log("ingredientsArr=============>", this.state.ingredientsArr);
        console.log("reviewDataDetails=============>", this.state.reviewDataDetails);
        console.log("reviewDetails=============>", this.state.reviewDetails);
        console.log("nutrionalFactsColor=============>", this.state.nutriFactColors);
        console.log("ratingDetails=============>", this.state.ratingDetails);
        console.log("ratingDetails=============>", this.state.setViewDetails);
        console.log("childPhoto=============>", this.state.childPhoto);

        // this.reviewsData();
        if (this.state.isApp) {
            actions.loadCallbackFile();
            document.querySelector('.footerList').style.bottom = "0px";
            document.querySelector(".askqueexpert").style.marginBottom = "0px";
            // document.querySelector(".askqueexpert").style.marginBottom = "29px";
            // document.querySelector(".app-header").style.background = "linear-gradient(to bottom,#000,1%, transparent)";
            document.querySelector(".app-header").style.background = "url(https://cdn.cdnparenting.com/brainbees/community/preact/public/media/topsheen1.png) no-repeat 0 0";
            document.querySelector(".app-header").style.backgroundSize = "cover";
            document.querySelector(".app-header").style.boxShadow = "none";
            document.querySelector(".app-header").style.borderBottom = "none";
            document.querySelector(".app-header .icon").style.color = "#FFF";
            document.querySelector(".app-header .M16_pink").style.color = "#FFF";
            document.querySelector(".sub-container").style.marginTop = "0";
            document.querySelector(".sub-container").style.marginBottom = "0";

            document.querySelector(".recipeDetailsbanner").style.color = "FFF";
            // document.querySelector(".app-header").style.opacity = "0.7";
            document.querySelector(".app-header").style.padding = "18px 15px 25px 15px";
            document.querySelector(".main-container").style.width = "auto";

            let appGTMJson = {
                "appurl": [
                    {
                      "pagetype": "appGaEvent",
                      "EventType": "appGaEvent",
                      "gaEvent": "",
                      "gajsonEvent": {
                        "recipe_id": this.state.recipeDetailData.recId,
                        "recipe_name": this.state.recipeDetailData.recName,
                        "season":this.state.recipeDetailData.seasonName
                      },
                      "webengageEvent": {
                        "eventname": "bmp_detail_page_viewed",
                        "eventdata": {
                            "recipe_id": this.state.recipeDetailData.recId,
                            "recipe_name": this.state.recipeDetailData.recName,
                            "season":this.state.recipeDetailData.seasonName,
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_detail_page_viewed",
                        "eventdata": {
                            "recipe_id": this.state.recipeDetailData.recId,
                            "recipe_name": this.state.recipeDetailData.recName,
                            "season":this.state.recipeDetailData.seasonName
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appGTMJson));



            if (this.state.scrollCountGA == "1") {
                document.querySelector('.madeSliderBlock').addEventListener('scroll', (event) => {
                    var swapLength = document.querySelectorAll('.made-food-img').length;
                    var srollLeftEle = document.querySelector('.madeSliderBlock').scrollLeft;
                    var _this = this;
                    if (swapLength >= (_this.qnaPageNo * 10) && _this.totalCount > (_this.qnaPageNo * 10)) {
                        if (srollLeftEle > 240 && srollLeftEle > _this.maxScroll) {
                            _this.maxScroll = srollLeftEle;
                            ++_this.qnaPageNo;
                            service.showLoader();
                            service.showTracking();
                            document.getElementById('pgNo').value = _this.qnaPageNo;
                            _this.reviewsDataScroll(_this.qnaPageNo, 10);
                        } else {
                            return false;
                        }
                    }

                    if (this.state.isApp && this.state.scrollCountGA == "1") {
                        this.setState({ scrollCountGA: "2" });
                        var obj = {};
                        obj.gaObj ="Meal Planner | Recipe Detail Page Actions_Mom's Made It|Swipe";
                            // "eventdata": {
                            //     "event_action": "Mom's Made It|Swipe",
                            //     "event_label": ""
                            // }
                        actions.trackEvent(obj);
                    }
                });
            }
        }
        if (window.innerWidth <= 767) {
            document.querySelector('.disclaimer-con').style.marginBottom = "0";
        }
        // document.querySelector('.footerList').style.bottom="0px";
        document.addEventListener("click", this.domClick);
        if (!global.ftk) {
            window.location.href = service.getRedirectUrl("/tools/baby-meal-plan/");
        }

        

        if (global.ftk == '') {
            console.log('global.ftk >>>>>', global.ftk);
            if (this.state.isApp) {
                actions.loginCallBack1();
            } else {
                service.showAlert("Please Login");
                window.location.href = global.loginUrl + '?URL=' + "/meal-planner";
                return false;
            }
        }
        if (Cookies.get(this.state.recipePhoto)) {
            if (Cookies.get("ratingCount") && Cookies.get("ratingCount") != undefined && Cookies.get("ratingCount") != '') {
                var rating = Cookies.get("ratingCount");
                this.setState({ rateCount: rating });
                this.rating('', rating);
            }

            var recipePhoto = Cookies.get(this.state.recipePhoto);
            document.querySelector(".recipePhoto").src = recipePhoto;
            document.getElementsByClassName('pictureblck')[0].style.display = 'block';
            document.querySelector('.ratePopup').classList.add("scrollCls");
            document.getElementsByClassName('raterecipe-overlay')[0].style.display = 'block';
            document.querySelector('body').style.overflow = "hidden";
            document.querySelector(".overScrollPic").scrollTop = 73;
            var review = Cookies.get("reviewTitle");
            // document.querySelector(".reviewTitle").value = review;
            this.setState({
                textValue: review,
                textValue1: Cookies.get("descTitle")
            })



            Cookies.set(this.state.recipePhoto, '');
        }
        if (navigator.onLine) {
            if (!this.state.initialData || (this.state.initialData && Object.keys(this.state.initialData).length < 1)) {
                service.showLoader();
                this.getRecipeDetails();

            } else {
                localStorage.setItem('getRecipeDetails', JSON.stringify(this.state.initialData));
            }
            if (!this.state.ingreDients || (this.state.ingreDients && Object.keys(this.state.ingreDients).length < 1)) {
                service.showLoader();
                this.getIngreDients();

            } else {
                localStorage.setItem('getIngreDients', JSON.stringify(this.state.ingreDients));
            }
            if (!this.state.reviewDetails || (this.state.reviewDetails && Object.keys(this.state.reviewDetails).length < 1)) {
                service.showLoader();
                this.reviewsData();

            } else {
                localStorage.setItem('AllreviewsData', JSON.stringify(this.state.reviewDetails));
            }
            if (!this.state.ratingAllDetails || (this.state.ratingAllDetails && Object.keys(this.state.ratingAllDetails).length < 1)) {
                service.showLoader();
                this.ratingAllDetails();

            } else {
                localStorage.setItem('ratingAllDetails', JSON.stringify(this.state.ratingAllDetails));
            }
            if (!this.state.setViewDetails || (this.state.setViewDetails && Object.keys(this.state.ratingAllDetails).length < 1)) {
                service.showLoader();
                this.setViewDetails();

            } else {
                localStorage.setItem('setViewDetails', JSON.stringify(this.state.setViewDetails));
            }
        } else {
            if (localStorage.getItem('getRecipeDetails')) {
                if (this.state.mealId != '') {
                    this.setState({
                        initialData: JSON.parse(localStorage.getItem('getRecipeDetails')),
                        recipeDetailData: JSON.parse(localStorage.getItem('getRecipeDetails'))['result'][0].firstrec,
                        nutrionalFacts: JSON.parse(localStorage.getItem('getRecipeDetails'))['result'][0].firstrec.nutrionalFacts,
                        nutriFactColors: JSON.parse(localStorage.getItem('getRecipeDetails'))['result'][0].firstrec.nutrionalFactsColors,
                        preparedArr: JSON.parse(localStorage.getItem('getRecipeDetails'))['result'][0].firstrec.preparedArr

                    }, () => { service.loadImages(); });
                } else {
                    this.setState({
                        initialData: JSON.parse(localStorage.getItem('getRecipeDetails')),
                        recipeDetailData: JSON.parse(localStorage.getItem('getRecipeDetails'))['result'][0],
                        nutrionalFacts: JSON.parse(localStorage.getItem('getRecipeDetails'))['result'][0].nutrionalFacts,
                        nutriFactColors: JSON.parse(localStorage.getItem('getRecipeDetails'))['result'][0].nutrionalFactsColors,
                        preparedArr: JSON.parse(localStorage.getItem('getRecipeDetails'))['result'][0].preparedArr
                    }, () => { service.loadImages(); });
                }
            }
            if (localStorage.getItem('getIngreDients')) {
                this.setState({
                    ingreDients: JSON.parse(localStorage.getItem('getIngreDients')),
                    ingredientsArr: JSON.parse(localStorage.getItem('getIngreDients'))['ingredientsArr']
                }, () => { service.loadImages(); });
            }
            if (localStorage.getItem('AllreviewsData')) {
                this.setState({
                    reviewDetails: JSON.parse(localStorage.getItem('AllreviewsData')),
                    reviewDataDetails: JSON.parse(localStorage.getItem('AllreviewsData'))['result']
                }, () => { service.loadImages(); });
                this.totalCount = JSON.parse(localStorage.getItem('AllreviewsData'))['userUploadedImgCount'];
            }
            if (localStorage.getItem('ratingAllDetails')) {
                this.setState({
                    ratingAllDetails: JSON.parse(localStorage.getItem('ratingAllDetails')),
                    ratingDetails: JSON.parse(localStorage.getItem('ratingAllDetails'))['result'][0]
                }, () => { service.loadImages(); });
            }
            if (localStorage.getItem('setViewDetails')) {
                this.setState({
                    setViewDetails: JSON.parse(localStorage.getItem('setViewDetails'))
                }, () => { service.loadImages(); });
            }
            service.hideLoader();
        }
        this.setState({ windowWidth: window.outerWidth });
        this.getStatsData();
        this.objtoArray(this.state.ratingDetails);
        setTimeout(() => {
            if (this.state.preparedArr && document.querySelector(".veggidiv") != null) {
                var totalvegDivHeigth = 0;
                var lengthDiv = this.state.preparedArr.length;
                for (var i = 0; i < lengthDiv - 1; i++) {
                    var heigthvegDiv = document.querySelector("#veggidiv_" + i).offsetHeight;
                    totalvegDivHeigth = totalvegDivHeigth + (heigthvegDiv + 10);
                }
                document.querySelector('.connecting-line').style.height = totalvegDivHeigth + "px";
            }
        }, 100);
    }
    domClick(event) {
        console.log("event Dom========>", event.target);
        // if (Cookies.get("reviewTitle")) {
        //     setTimeout(() => {
        //         var review = Cookies.get("reviewTitle");
        //         document.querySelector(".reviewTitle").value = review;
        //     }, 200);
        // }
        // if (Cookies.get("descTitle")) {
        //     setTimeout(() => {
        //         document.querySelector("#descTitle").value = Cookies.get("descTitle");
        //     }, 300);
        // }
        if (event.target.classList.contains('share-overlay')) {
            let ary = document.getElementsByClassName('sharing-options');
            for (let i = 0; i < ary.length; i++) {
                ary[i].style.display = 'none';
            }
            if (document.getElementsByClassName('share-overlay')[0]) {
                document.getElementsByClassName('share-overlay')[0].style.display = 'none';
            }
            if (document.getElementsByClassName('raterecipe-overlay')[0]) {
                document.getElementsByClassName('raterecipe-overlay')[0].style.display = 'none';
                document.querySelector('body').style.overflow = "visible";
            }
        }
        if (event.target.classList.contains("ratePopup") || event.target.classList.contains("raterecipe-overlay")) {
            document.getElementsByClassName('raterecipe-overlay')[0].style.display = 'none';
            document.querySelector('body').style.overflow = "visible";
        }
    }
    getRecipeDetails() {
        // var recFlag = Cookies.get("RecipeList");
        if (this.state.mealId != '') {
            // var url= global.api_url + "dietplan/getreceipemealdetailsPage";
            var url = global.api_ci_url + "MealPlanner/getReceipeMealdetails";
            // var mealId = Cookies.get("mealId");
            var postData = {
                "mealid": this.state.mealId
            }
        } else {
            var postData = {
                "recipeid": this.state.recipeId
            }
            // var url = global.api_url + "dietplan/getreceipeDetails";
            var url = global.api_ci_url + "MealPlanner/getReceipeDetails";
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                if (this.state.mealId != '') {
                    this.setState({ initialData: json, recipeDetailData: json['result'][0].firstrec, nutrionalFacts: json['result'][0].firstrec.nutrionalFacts, preparedArr: json['result'][0].firstrec.preparedArr }, () => {
                        this.getStatsData(); service.hideLoader();
                    });
                } else {
                    this.setState({ initialData: json, recipeDetailData: json['result'][0], nutrionalFacts: json['result'][0].nutrionalFacts, nutriFactColors: json['result'][0].nutrionalFactsColors, preparedArr: json['result'][0].preparedArr }, () => {
                        this.getStatsData(); service.hideLoader();
                    });
                }

            }
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    getIngreDients() {
        // var resipeId = Cookies.get("resipeId");
        var postData = {
            "recipeid": this.state.recipeId
        }
        // var url = global.api_url + "dietplan/getreceingredients";
        var url = global.api_ci_url + "MealPlanner/getReceIngredients";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                this.setState({ ingreDients: json['result'][0], ingredientsArr: json['result'][0]['ingredientsArr'] }, () => {
                    service.hideLoader();
                });
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    reviewsData() {
        // var url = global.api_url + "dietplan/getreviewdetails";
        var url = global.api_ci_url + "MealPlanner/getReviewDetails";
        var postData = {
            "recipeid": this.state.recipeId,
            "pageno": "1",
            "pagesize": "10"
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                this.setState({ reviewDetails: json, reviewDataDetails: json['result'] }, () => {
                    this.momsliderWidthCal(); service.hideLoader();
                });
                this.totalCount = json['userUploadedImgCount'];
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    reviewsDataScroll(pageNo, pageSize) {
        // var url = global.api_url + "dietplan/getreviewdetails";
        var url = global.api_ci_url + "MealPlanner/getReviewDetails";
        var postData = {
            "recipeid": this.state.recipeId,
            pageno: pageNo,
            pagesize: pageSize
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == 1) {
                if (this.state.reviewDetails.userImageArr.length > 0) {
                    if (pageSize == (pageNo * 10)) {
                        this.setState({ reviewDetails: json['userImageArr'] }, () => { this.momsliderWidthCal(); service.loadImages(); actions.loadReadMore(); });
                    } else {
                        let ary = this.state.reviewDetails.userImageArr;
                        let reviewData = this.state.reviewDetails;
                        reviewData.userImageArr = ary.concat(json['userImageArr']);
                        this.setState({ reviewDetails: reviewData }, () => { this.momsliderWidthCal(); service.loadImages(); actions.loadReadMore(); });
                    }
                } else {
                    localStorage.setItem('AllreviewsData', JSON.stringify(json));
                    localStorage.setItem('reviewsData', JSON.stringify(json['result']));
                    this.totalCount = parseInt(json['userUploadedImgCount']);
                    this.setState({ reviewDetails: json['userImageArr'] }, () => { this.momsliderWidthCal(); service.loadImages(); actions.loadReadMore(); });
                }
            }
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    ratingAllDetails() {
        var url = global.api_ci_url + "MealPlanner/getRatingdetail";
        // var reciId = Cookies.get("resipeId");
        var postData = {
            "recipeid": this.state.recipeId
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                this.setState({ ratingAllDetails: json, ratingDetails: json['result'][0] }, () => {
                    service.hideLoader();
                });
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }
    setViewDetails() {
        let postData;
        let url = global.api_ci_url + "MealPlanner/SetrecUserView";
        // let url = global.api_url + "dietplan/setrecuserview";
        postData = {
            "recipeid": this.state.recipeId
        }
        service.postServiceCall(url, postData).then((json) => {
            console.log("setviewDetails =====", json);
            if (json['msg'] == "1") {
                service.hideLoader();
            }
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
            service.hideTracking();
        });

    }
    openMealPopupSlider(event, e) {
        document.querySelector('.mp-slider').style.display = 'none';
        for (let i = 1; i < 4; i++) {
            if (document.getElementById('mp-slider' + i).style.display == 'block') {
                document.getElementById('mp-slider' + i).style.display == 'none';
            }
        }
        if (e == 'up') {
            document.getElementById('mp-slider' + event).style.display = 'block';
            document.getElementById('mpup' + event).style.display = 'none';
            document.getElementById('mpdown' + event).style.display = 'block';
        } else {
            document.getElementById('mpdown' + event).style.display = 'none';
            document.getElementById('mp-slider' + event).style.display = 'none';
            document.getElementById('mpup' + event).style.display = 'block';
        }
    }
    rateRecipe() {
        if (this.state.isApp) {

            let appGTMJson = {
                "appurl": [
                    {
                      "pagetype": "appGaEvent",
                      "EventType": "appGaEvent",
                      "gaEvent": "",
                      "gajsonEvent": {
                        "recipe_id": this.state.recipeDetailData.recId,
                        "recipe_name": this.state.recipeDetailData.recName,
                        "action_type":"rate recipe click",
                        "description":"",
                        "rating":""
                      },
                      "webengageEvent": {
                        "eventname": "bmp_recipe_rating_actions",
                        "eventdata": {
                            "recipe_id": this.state.recipeDetailData.recId,
                        "recipe_name": this.state.recipeDetailData.recName,
                            "action_type":"rate recipe click",
                            "description":"",
                            "rating":"",
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_recipe_rating_actions",
                        "eventdata": {
                            "recipe_id": this.state.recipeDetailData.recId,
                            "recipe_name": this.state.recipeDetailData.recName,
                            "action_type":"rate recipe click",
                            "description":"",
                            "rating":""
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appGTMJson));

            var obj = {};
            obj.gaObj = "Meal Planner | Recipe Detail Page Actions_Rate Recipe_Open";
                // "eventdata": {
                //     "event_action": "Rate Recipe",
                //     "event_label": "Open"
                // }
            actions.trackEvent(obj);
        }
        document.getElementsByClassName('raterecipe-overlay')[0].style.display = 'block';
        document.querySelector('body').style.overflow = "hidden";
    }
    onCameraSelect() {
        Cookies.set("ratingCount", this.state.rateCount);
        Cookies.set("reviewTitle", document.querySelector(".reviewTitle").value);
        Cookies.set("descTitle", document.querySelector(".descTitle").value);
        // document.getElementsByClassName('pictureblck')[0].style.display = 'block';
        var hostUrl = window.location.href;
        if (hostUrl.split("/")[5]) {
            var recipeId = hostUrl.split("/")[5];
            if (recipeId && recipeId.includes('#')) {
                recipeId = recipeId.split('#')[0];
            }
            if (recipeId && recipeId.includes('&')) {
                if (recipeId.split('&').length > 1) {
                    recipeId = recipeId.replace("&from=app", "");
                } else {
                    recipeId = recipeId.split('&')[0];
                }
            }
            if (recipeId && recipeId.includes('?from=app')) {
                recipeId = recipeId.replace("?from=app", "");
            }
            recipeId = recipeId.replace("?", "&");
            window.location.href = service.getRedirectUrl('/tools/baby-meal-plan/upload-recipe' + '?' + recipeId);
        }
    }
    oncloseCamera() {
        document.getElementsByClassName('pictureblck')[0].style.display = 'none';
        document.querySelector('.ratePopup').classList.remove("scrollCls");
        document.querySelector('.recipePhoto').src = "";
        Cookies.set(this.state.recipePhoto, '');
    }
    onclosePopup() {
        if (this.state.isApp) {
            var obj = {};
            obj.gaObj = "Meal Planner | Recipe Detail Page Actions_Rate Recipe_Close";
                // "eventdata": {
                //     "event_action": "Rate Recipe",
                //     "event_label": "Close"
                // }
            actions.trackEvent(obj);
        }
        document.getElementsByClassName('raterecipe-overlay')[0].style.display = 'none';
        document.querySelector('body').style.overflow = "visible";
        document.querySelector('.ratePopup').classList.add("scrollCls");
        Cookies.set(this.state.recipePhoto, '');
    }
    objtoArray(ratingDetails) {
        var fooArray = Object.entries(ratingDetails);
        var arr = [];
        fooArray.reverse().forEach(([key, value]) => {
            arr.push(value);
        });
        console.log("this.state.reviewDetails================>", arr);
        this.setState({ ratingDetails: arr });
    }

    rating(e, count) {
        let ratingList = document.querySelectorAll(".ratImg");
        for (var i = 0; i < ratingList.length; i++) {
            ratingList[i].src = 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/rating-star.png';
        }
        for (var i = 0; i < count; i++) {
            ratingList[i].src = 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/big-star.png';
        }
        this.setState({ rateCount: count });
       
        document.querySelector(".percent1").innerText = count * 20 + "%";
        document.querySelector(".percent").innerText = count * 20 + "%";
        document.querySelector("#likeit").innerText = "You Liked It";
        document.getElementById("errratesubmit").style.display = "none";
        if (this.state.isApp) {
            var rateUser = count * 20 + "%";
            var obj = {};
            obj.gaObj = "Meal Planner | Recipe Detail Page Actions_Rate Recipe_"+rateUser;
                // "eventdata": {
                //     "event_action": "Rate Recipe",
                //     "event_label": rateUser
                // }
            actions.trackEvent(obj);
        }
    }
    allReviews() {
        var recipeDName = service.genquestionurl(this.state.recipeName);
        var MyRecipe = recipeDName;
        Cookies.set(MyRecipe, this.state.recipeId);
        window.location.href = service.getRedirectUrl('/tools/baby-meal-plan/' + recipeDName.replace(/ /g, "-") + '/reviews'+'?recp='+this.state.recipeId);
    }
    onSubmitrecipe() {
        if (navigator.onLine) {
            var getRecipeimg ='';
            if (document.querySelector(".check").classList.contains("isChecked")) {
                var getRecipeimg = document.querySelector(".recipePhoto").attributes.src.value;
                var isShow = 1;
            } else {
                var getRecipeimg = document.querySelector(".recipePhoto").attributes.src.value;
                var isShow = 0;
            }
            if (this.state.rateCount == '') {
                this.state.rateCount = '';
                document.getElementById("errratesubmit").innerHTML = "Please rate the recipe.";
                document.getElementById("errratesubmit").style.display = "block";
            } else {
                document.getElementById("errratesubmit").innerHTML = "";
                this.state.rateCount = this.state.rateCount;
            }
            if(document.querySelector(".descTitle").value != ""){
                if(document.querySelector(".descTitle").value.length <= 10){
                    var flag = 2;
                    document.querySelector(".minchar").innerHTML = "Please enter minimum 10 characters.";
                    document.querySelector(".minchar").classList.add('errratecharsubmit');
                    document.querySelector(".errratecharsubmit").style.display = 'block';
                }else{
                    var flag=1;
                }
            }else{
                var flag=1;
            }
            var postData = {
                "starNumber": this.state.rateCount,
                "recipeid": this.state.recipeId,
                "reviewTile": document.querySelector(".reviewTitle").value,
                "reviewDes": document.querySelector(".descTitle").value,
                "userUploadedImg": getRecipeimg,
                "isShow": isShow
            };
            if (this.state.rateCount != '' && flag=="1") {
                var url = global.api_ci_url + "MealPlanner/setStarRating";
                service.showLoader();
                // var url = global.api_url + "dietplan/setstarrating";
                service.postServiceCall(url, postData).then((json) => {
                    if (json['result'] == "success") {
                        document.querySelector(".ratbtnn").style.display = "none";
                        document.querySelector(".ratedblock").style.display = "block";
                        var set = "reciID_" + this.state.recipeId
                        Cookies.set("ratingSet", set);
                        // console.log(json['result']);
                        // Cookies.set("ratingCount", '');
                        Cookies.set("reviewTitle", '');
                        Cookies.set("descTitle", '');
                        Cookies.set(this.state.recipePhoto, '');
                        this.reviewsData();
                        document.getElementsByClassName('raterecipe-overlay')[0].style.display = 'none';
                        document.querySelector('body').style.overflow = "visible";
                    }
                    service.hideLoader();
                });
                var eventName = (document.querySelector(".reviewTitle").value != '' && document.querySelector(".descTitle").value != '') ? 'Write a  review' : (getRecipeimg != '') ? 'Add  a photo' : 'Submit';
                if (this.state.isApp) {

                    let appGTMJson = {
                        "appurl": [
                            {
                              "pagetype": "appGaEvent",
                              "EventType": "appGaEvent",
                              "gaEvent": "",
                              "gajsonEvent": {
                                "recipe_id": this.state.recipeDetailData.recId,
                                "recipe_name": this.state.recipeDetailData.recName,
                                "action_type":"rating submitted",
                                "description":document.querySelector(".descTitle").value,
                                "rating":this.state.rateCount
                              },
                              "webengageEvent": {
                                "eventname": "bmp_recipe_rating_actions",
                                "eventdata": {
                                    "recipe_id": this.state.recipeDetailData.recId,
                                "recipe_name": this.state.recipeDetailData.recName,
                                    "action_type":"rating submitted",
                                    "description":document.querySelector(".descTitle").value,
                                    "rating":this.state.rateCount,
                                    "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                                }
                              },
                              "jarvisEvent": {
                                "eventname": "bmp_recipe_rating_actions",
                                "eventdata": {
                                    "recipe_id": this.state.recipeDetailData.recId,
                                    "recipe_name": this.state.recipeDetailData.recName,
                                    "action_type":"rating submitted",
                                    "description":document.querySelector(".descTitle").value,
                                    "rating":this.state.rateCount
                                }
                              }
                            }
                          ]
                        }; 
                        service.jsontracker(JSON.stringify(appGTMJson));

                    var obj = {};
                    obj.gaObj ="Meal Planner | Recipe Detail Page Actions_Rate Recipe_" + eventName;
                        // "eventdata": {
                        //     "event_action": "Rate Recipe",
                        //     "event_label": eventName
                        // }
                    actions.trackEvent(obj);
                }
            } else {
                return false;
            }
        } else {
            document.getElementsByClassName('raterecipe-overlay')[0].style.display = 'none';
            service.showAlert("Please Check Internet Connection!!!");
            return false;
        }
    }
    momsliderWidthCal() {
        // setTimeout(()=>{
        if (document.querySelector('.madeSliderBlock') && document.querySelector('.madeSliderBlock') != null && document.querySelector('.made-food-img') != null) {
            var eleWidth = document.querySelector('.made-food-img').clientWidth + 10;
            var eleLen = document.querySelectorAll('.made-food-img').length;
            document.querySelector('.madeSliderBlock ul').style.width = (eleWidth * eleLen) + "px";
        }
        // },200)
    }
    getStatsData() {
        this.momsliderWidthCal();
        var setrating = Cookies.get("ratingSet");
        if (Cookies.get("babyAge")) {
            var babyAge = JSON.parse(Cookies.get("babyAge")).toString().replace(/,/g, '');
        }
        if (setrating == "reciID_" + this.state.recipeId || this.state.ratingAllDetails.isRating == 1) {
            if (this.state.ratingAllDetails.starNumber != '' && this.state.ratingAllDetails.starNumber != undefined) {
                var rating = parseInt(this.state.ratingAllDetails.starNumber);
                this.setState({ rateCount: rating });
                this.rating('', rating);
            } else if (Cookies.get("ratingCount") && Cookies.get("ratingCount") != undefined && Cookies.get("ratingCount") != '') {
                var rating = Cookies.get("ratingCount");
                this.setState({ rateCount: rating });
                this.rating('', rating);
            }
            document.querySelector(".ratbtnn").style.display = "none";
            document.querySelector(".ratedblock").style.display = "block";
        }
        this.setState({ babyAge: babyAge });
        // const sublist = [];
        // var starCount = this.state.recipeDetailData.starNumber;
        // if (starCount != '') {
        //     if (starCount != 0) {
        //         for (var i = 0; i < 5; i++) {
        //             if (i < starCount) {
        //                 sublist.push(
        //                     <span className="R11_9e staricon activestar" data-icon-font="-"></span>
        //                 );
        //             } else {
        //                 sublist.push(
        //                     <span className="R11_9e staricon" data-icon-font="-"></span>
        //                 );
        //             }
        //         }
        //     }
        //     this.setState({ starRate: sublist });
        // }
        this.cookTime(this.state.recipeDetailData.cookTime, "cookTime");
        this.cookTime(this.state.recipeDetailData.prepTime, "prepTime");
        this.cookTime(this.state.recipeDetailData.totalTime, "totalTime");
        const sublistul = [];
        var items = [];
        var fooArray = Object.entries(this.state.nutrionalFacts);
        fooArray.forEach(([key, value]) => {
            items.push(key);

            sublistul.push(parseFloat(value));
        });
        const nutrionalFactsColor = [];
        const nutrionalFactsColorr = [];

        // var items = [];
        var fooArray1 = Object.entries(this.state.nutriFactColors);
        fooArray1.forEach(([key, value]) => {
            nutrionalFactsColor.push(value);
        });
        // var fooArray3 = Object.entries(this.state.nutriFactColors);
        // fooArray3.forEach(([key1, value1]) => {
        //     nutrionalFactsColorr.push(value1);
        // });
        this.setState({ nutriFactsColorArr: nutrionalFactsColor });
        this.setState({ nutrionalItems: items });
        console.log("items====>", items);
        console.log("value====>", sublistul);
        console.log("nutrionalFactsColor===============>", nutrionalFactsColor);
        if (this.isChatJsLoaded) {
            actions.nutrionalFacts(sublistul, items, nutrionalFactsColor);
        } else {
            service.loadChatJsFile(this);
        }
    }
    cookTime(cookTimeData, flag) {
        let cookTime = [];
        if (cookTimeData && cookTimeData != '') {
            var splitAry = cookTimeData.split(':');
            if (splitAry[0] != '00') {
                cookTime.push(splitAry[0] + " Hours");;
            }
            if (splitAry[1] != "00") {
                if (cookTime.length > 1) {
                    cookTime.push(":" + splitAry[1] + " Mins");
                } else {
                    cookTime.push(splitAry[1] + " Mins");
                }
            } if (splitAry[2] !== "00") {
                if (cookTime.length > 1) {
                    cookTime.push(":" + splitAry[2] + " Sec");
                } else {
                    cookTime.push(splitAry[2] + " Sec");
                }
            }
            if (cookTime == '') {
                cookTime.push('00');
            }
            if (flag == "cookTime") {
                this.setState({ cookTime: cookTime });
            } else if (flag == "prepTime") {
                this.setState({ prepTime: cookTime });
            } else if (flag == "totalTime") {
                this.setState({ totalTime: cookTime });
            }
        }
    }
    checkTnc() {
        this.setState({ tncAgree: !this.state.tncAgree });
    }
    handleChangecmnt1(event) {
        if (event.target.value.length <= 100) {
            Cookies.set("reviewTitle", document.querySelector(".reviewTitle").value);
            this.setState({
                textValue: event.target.value
            })
        }
        var input = event.target.value;
        this.setState({
            chars_left: this.state.text_max - input.length
        });
    }
    handleChangecmnt2(event) {
        if (event.target.value.length <= 200) {
            Cookies.set("descTitle", document.querySelector(".descTitle").value);
            this.setState({
                textValue1: event.target.value
            })
        }
        if (event.target.value.length <= 10) {
            document.querySelector(".minchar").innerHTML = "Please enter minimum 10 characters.";
            document.querySelector(".minchar").classList.add('errratecharsubmit');
	        document.querySelector(".errratecharsubmit").style.display = 'block';
        } else {
            document.querySelector(".minchar").innerHTML = "Minimum 200 characters";
            document.querySelector(".minchar").classList.remove('errratecharsubmit');
	        // document.querySelector(".errratecharsubmit").style.display = 'none';
        }
        // if(event.target.value.length <= 35){
        //     document.querySelector('.descTitle').style.height="17px";
        // }else{
        //     document.querySelector('.descTitle').style.height="auto";
        // }
        var input = event.target.value;
        this.setState({
            chars_left1: this.state.text_max1 - input.length
        });
        this.calculateMsgRows();
    }
    calculateMsgRows() {
        document.getElementById('descTitle').rows = 1;
        let rows = (document.getElementById('descTitle').scrollHeight) / 17;
        if (rows > 0 && rows < 6) {
            document.getElementById('descTitle').rows = rows;
        } else if (rows <= 1) {
            document.getElementById('descTitle').rows = 1;
        } else if (rows >= 5) {
            document.getElementById('descTitle').rows = 5;
        }
    }
    AskQnaQuetion() {
        if (this.state.isApp) {

            let appGTMJson = {
                "appurl": [
                    {
                      "pagetype": "appGaEvent",
                      "EventType": "appGaEvent",
                      "gaEvent": "",
                      "gajsonEvent": {
                        "recipe_id": this.state.recipeDetailData.recId,
                        "recipe_name": this.state.recipeDetailData.recName,
                        "action_type":"ask question button click",
                        "shared_platform":""
                      },
                      "webengageEvent": {
                        "eventname": "bmp_detail_page_actions",
                        "eventdata": {
                            "recipe_id": this.state.recipeDetailData.recId,
                        "recipe_name": this.state.recipeDetailData.recName,
                            "action_type":"ask question button click",
                            "shared_platform":"",
                            "sendWithoutGtm": "yes"          //mixpanel event send without GTM
                        }
                      },
                      "jarvisEvent": {
                        "eventname": "bmp_detail_page_actions",
                        "eventdata": {
                            "recipe_id": this.state.recipeDetailData.recId,
                        "recipe_name": this.state.recipeDetailData.recName,
                            "action_type":"ask question button click",
                            "shared_platform":""
                        }
                      }
                    }
                  ]
                }; 
                service.jsontracker(JSON.stringify(appGTMJson));


            var obj = {};
            obj.gaObj = "Meal Planner | Recipe Detail Page Actions_Ask a Question Expert";
                // "eventdata": {
                //     "event_action": "Ask a Question Expert",
                //     "event_label": ""
                // }
            actions.trackEvent(obj);
            var deepjson = {
                "appurl": [{
                    "pagetype": "communityaskparentingquestion",
                    "requestURL": "https://parenting.firstcry.com/qna/questions-answers/?from=app"
                }]
            };
            service.jsontracker(JSON.stringify(deepjson));
        } else {
            Cookies.set("openAskQue", "MealPlanner");
            window.location.href = service.getRedirectUrl("/qna/questions-answers/");

        }
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.domClick);
    }
    changeData(id, type, status) {
        let mealSelRecp = this.state.recipeDetailData;
        if (type == "bookmark") {
            if (parseInt(status) == 1) {
                mealSelRecp.isBookmarked = 1;
            } else if (parseInt(status) == 0) {
                mealSelRecp.isBookmarked = 0;
            }
        } else {
            if (parseInt(status) == 1) {
                mealSelRecp.isLike = 1;
                mealSelRecp.likeCount = parseInt(mealSelRecp.likeCount) + 1;
            } else if (parseInt(status) == 0) {
                mealSelRecp.isLike = 0;
                mealSelRecp.likeCount = parseInt(mealSelRecp.likeCount) - 1;
            }
        }
        this.setState({ recipeDetailData: mealSelRecp });
    }
    onrecipeClickGA() {
        if (this.state.isApp) {
            var loginStatus = (global.ftk && global.ftk != "") ? 'Logged in' : 'Non-Logged in';
            var eventName = 'Meal Planner| ' + loginStatus + '|Homepage Actions';
            var eventAction = '';
            var obj = {};
            obj.gaObj = "Meal Planner | Recipe Detail Page Actions_Mom's Made It| Recipe Click";
                // "eventdata": {
                //     "event_action": "Mom's Made It| Recipe Click",
                //     "event_label": ""
                // }
            actions.trackEvent(obj);
        }
    }
    render() {
        let receiptname = this.state.recipeName
        console.log("receiptname in render =",receiptname)
        return (
            <main className="main-container meal-planner">
                <Helmet
                    title={this.state.metaTitle}
                    meta={[
                        { "name": "description", "content": "Learn how to make a " + this.state.recipeName + ". This baby meal planner provides you with an easy and simple recipe to prepare a nutritious wheat porridge for your child. " },
                        { "name": "keywords", "content": this.state.recipeName + " recipe, how to make a " + this.state.recipeName + " for baby" },
                        { "name": "atdlayout", "content": "" },
                        { "name": "robots", "content": "noindex, nofollw" },
                        { "property": "og:type", "content": "website" },
                        { "property": "og:title", "content": this.state.recipeDetailData.recName },
                        { "property": "og:description", "content": this.state.recipeDetailData.recDescription },
                        { "property": "og:url", "content": global.currentURL },
                        { "property": "og:image", "content": this.state.recipeDetailData.recImg },
                        // <!-- Twitter Meta Tags -->
                        { "name": "twitter:image", "content": this.state.recipeDetailData.recImg },
                        { "name": "twitter:title", "content": this.state.recipeDetailData.recName },
                        { "name": "twitter:description", "content": this.state.recipeDetailData.recDescription }
                        
                    ]}
                />
                {!this.state.isApp &&
                    <div className="title" id="recepieView"  >
                        <div className="breadcrumb R11_9e">
                            <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span><a href={global.redirect_url + "tools/baby-meal-plan"} className="R11_9e">Baby Meal Planner</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span>{this.state.recipeName}</span>
                        </div>
                        <h1 id="recView" data-recepie={this.state.recipeDetailData.recName} data-receId={this.state.recipeDetailData.recId} data-texture={this.state.recipeDetailData.texture} data-receCat={this.state.recipeDetailData.receCat} data-season={this.state.recipeDetailData.seasonName} className="B24_00">{receiptname} For Babies & Toddlers </h1>
                    </div>
                }
                {this.state.isApp &&
                    <div className="app-header">
                        <span data-icon-font="s" className="icon" onClick={() => onBackPressed()}></span>
                        <span className="M16_pink">Recipe Details</span>
                    </div>
                }
                <div className="sub-container left" style={this.state.isApp ? { marginTop: '50px' } : {}}>
                    <div className="data-container left">
                        <div className="meal-planner-banner recipeDetailsbanner">
                            <div className="bannerimg">
                                {this.state.recipeDetailData && this.state.recipeDetailData.recImg != undefined && this.state.recipeDetailData.recImg &&
                                    <img src={this.state.recipeDetailData.recImg.replace("http://", "https://")} 
                                    // onError={(e) =>
                                    //     { 
                                    //       e.target.onerror = null; // stop infinite loop
                                    //       e.target.src = this.state.recipeDetailData && this.state.recipeDetailData.recImg != undefined && this.state.recipeDetailData.recImg.replace("http://", "https://")
                                    //     } 
                                    // }
                                    alt={this.state.recipeName + " for Babies & Toddlers.jpg"} 
                                    title={this.state.recipeName + " for Babies & Toddlers.jpg"} 
                                    name={this.state.recipeName + " for Babies & Toddlers.jpg"} />
                                }
                            </div>

                            <div className="bottom-shadow details-shadow"></div>
                            <div className="typeblock">
                                {this.state.recipeDetailData && this.state.recipeDetailData.recType &&
                                    <div className="box-foodtype left">
                                        <span className="R11_FF">#{this.state.recipeDetailData.recType}</span>
                                    </div>
                                }
                                <div className={this.state.recipeDetailData && this.state.recipeDetailData.receCat == "veg" ? "box-img-veg" : "box-img-veg box-img-nonveg"}>
                                    <div className={this.state.recipeDetailData && this.state.recipeDetailData.receCat == "veg" ? "box-img-veg-mark" : "box-img-veg-mark nonveg-mark"}></div>
                                </div>
                            </div>
                        </div>
                        <div className="recipeDetailsBlock">
                            <div className="recipe-name R17_21">
                                {this.state.recipeDetailData.recName}
                            </div>
                            {this.state.recipeDetailData.isBookmarked > 0 ?
                                <span className="icon bookmarkicon active" onClick={() => { actions.setBookMark(this.state.recipeDetailData.recId ? this.state.recipeDetailData.recId : this.state.recipeDetailData.recipeId, 0, "recipeDetails", this) }}>
                                    <img className="recipeDetails" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Layer 1.png" />
                                    {/* <span data-icon-font="&#xe04e;" className="icon bkIcon"></span> */}
                                </span>
                                :
                                <span className="icon bookmarkicon" onClick={() => { actions.setBookMark(this.state.recipeDetailData.recId ? this.state.recipeDetailData.recId : this.state.recipeDetailData.recipeId, 1, "recipeDetails", this, this.state.isApp, "", "", this.state.recipeDetailData.recName) }}>
                                    <img className="recipeDetails" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/unbookmark.png" alt="Unbookmark Icon" title="Unbookmark Icon" />
                                </span>
                            }
                            <div className="recipe-desc R14_75">
                                <span>{this.state.recipeDetailData.recDescription}</span>
                            </div>
                            <div className="seemore R13_link" onClick={(e) => actions.seeMoreClick(e, '325px', "detailsPage", this.state.isApp)} id="dev_rcp_dtl_mr">See More</div>
                            {this.state.secondReciepId && this.state.secondReciepId.length > 0 && this.state.secondReciepId.map((secondRecipe, index5) =>
                                <div key={index5} className="recipeLink">
                                    <a href={service.getRedirectUrl("/tools/baby-meal-plan/" + secondRecipe.recName.trim().replace(/ /g, "-") + "?recId=" + secondRecipe.recId)} target="_blank">{secondRecipe.recName} </a>
                                </div>
                            )}
                            <div className="recipe-age R13_9e"> For {this.state.babyAge} old</div>
                            <div className="detail-rate-block">
                                {this.state.reviewDetails && this.state.reviewDetails.ratingpercentcount != 0 &&
                                    <div className="detail-rating left">
                                        <span className="R12_FF">{this.state.reviewDetails.ratingpercentcount}</span>
                                    </div>
                                }
                                {/* <div className="starblock left">
                                    {this.state.starRate} */}
                                {/* <span className="R11_9e staricon activestar" data-icon-font="-"></span>
                                    <span className="R11_9e staricon activestar" data-icon-font="-"></span>
                                    <span className="R11_9e staricon activestar" data-icon-font="-"></span>
                                    <span className="R11_9e staricon activestar" data-icon-font="-"></span>
                                    <span className="R11_9e staricon" data-icon-font="-"></span> */}
                                {/* </div> */}
                                <div className="reviewcnt R13_75 left">{this.state.reviewDetails.reviewCount} reviews</div>
                                <div className="texture M14_21 right">Texture: {this.state.recipeDetailData.texture}</div>
                            </div>
                            <div className="allerInfo M15_21">Allergen Information: </div>
                            <div className="allerDesc R14_61">{this.state.recipeDetailData.allergen}
                            </div>
                            <div className="rec-block">
                                <div className="slidblock" id="slidblock1">
                                    <div className="slidup">
                                        {/* <span className="slidicon" data-icon-font="%"></span> */}
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Clock Grey.svg" className="slidicon" />
                                        <span className="slidtext M10_42">Time</span>
                                    </div>
                                    <div className="sliddown">
                                        <span className="M14_42">{this.state.totalTime}</span>
                                    </div>
                                </div>
                                <div className="slidblock" id="slidblock2">
                                    <div className="slidup">
                                        {/* <span className="slidicon" data-icon-font="&#xe045;"></span> */}
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Allergen.svg" className="slidicon" />
                                        <span className="slidtext M10_42">Season</span>
                                    </div>
                                    <div className="sliddown">
                                        <span className="M14_42">{this.state.recipeDetailData.seasonName}</span>
                                    </div>
                                </div>
                                <div className="slidblock" id="slidblock3">
                                    <div className="slidup">
                                        {/* <span className="slidicon" data-icon-font="%"></span> */}
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Clock Grey.svg" className="slidicon" />
                                        <span className="slidtext M10_42">Region</span>
                                    </div>
                                    <div className="sliddown">
                                        <span className="M14_42">{this.state.recipeDetailData.region_name}</span>
                                    </div>
                                </div>
                                <div className="slidblock" id="slidblock4">
                                    <div className="slidup">
                                        {/* <span className="slidicon" data-icon-font="&#xe045;"></span> */}
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Allergen.svg" className="slidicon" />
                                        <span className="slidtext M10_42">KCAL</span>
                                    </div>
                                    <div className="sliddown">
                                        <span className="M14_42">{this.state.recipeDetailData.totalCalories}</span>
                                    </div>
                                </div>
                                <div className="slidblock" id="slidblock5">
                                    <div className="slidup">
                                        {/* <span className="slidicon" data-icon-font="&#xe045;"></span> */}
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Allergen.svg" className="slidicon" />
                                        <span className="slidtext M10_42">Course</span>
                                    </div>
                                    <div className="sliddown">
                                        <span className="M14_42">{this.state.recipeDetailData.mealCourse}</span>
                                    </div>
                                </div>
                                <div className="slidblock" id="slidblock6">
                                    <div className="slidup">
                                        {/* <span className="slidicon" data-icon-font="%"></span> */}
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Clock Grey.svg" className="slidicon" />
                                        <span className="slidtext M10_42">Method</span>
                                    </div>
                                    <div className="sliddown">
                                        <span className="M14_42">{this.state.recipeDetailData.cookingMethod}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="divider-line"></div>
                            <div className="meal-card-actions">
                                <div className="card-views social-actions">
                                    <span data-icon-font="$" className="icon R13_61 view-icon"></span>
                                    <span className="like-count view_count R13_61">{this.state.recipeDetailData.viewCount}</span>
                                    <span className="activity-txt R13_61"> Views</span>
                                </div>
                                <div className="card-views social-actions like-algn">
                                    {this.state.recipeDetailData && this.state.recipeDetailData.isLike > 0 ?
                                        (<span>
                                            <span data-icon-font="&#xe009;" className="icon R13_61 active like-icon"></span>
                                            <span className="like-count R13_61">
                                                <span className="total_likes">
                                                    {this.state.recipeDetailData['likeCount']}
                                                </span>
                                                <span className="activity-txt"> Likes</span>
                                            </span>
                                        </span>
                                        ) :
                                        (
                                            <span>
                                                {/* 3rd time change */}
                                                <span data-icon-font="&#xe009;" className="icon R13_61 like-icon" id="dev_lk_dtl_btn" onClick={(e) => actions.likeArticle("", this.state.recipeDetailData.recId, e, this.state.recipeDetailData.likeCount, "", this.state.recipeDetailData.recName, "", 1, this, this.state.isApp, "recipeDetails")}>
                                                </span>
                                                <span className="like-count R13_61">
                                                    <span className="total_likes">
                                                        {this.state.recipeDetailData['likeCount']}
                                                    </span>
                                                    <span className="activity-txt"> Likes</span>
                                                </span>
                                            </span>
                                        )}
                                </div>
                                <div className="card-share right social-actions">
                                    <div className="R13_61 right share-icon" onClick={(e) => actions.shareOn(e, "1", this.state.isApp, this.state.recipeDetailData.recImg, this.state.recipeDetailData.recName, "recipeDetails", this.state.recipeDetailData.recDescription,"","",this.state.recipeDetailData)}>
                                        <div className="fb-icon left">
                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook-icon.png" alt="Facebook" title="Facebook" />
                                        </div>
                                        <div data-icon-font="" className="whtapp-icon left"></div>
                                        <div className="left share-txt R13_61">Share</div>
                                    </div>
                                    <div className="sharing-options dev_dtl" id={"share_1"}>
                                        <ul className="left">
                                            <li className="whatsapp-share left" onClick={(e) => actions.shareArticle('whatsapp', "")}>
                                                <span className="M16_61 social-share" id="whatsapp">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="fetusfacebookimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                                                </span>
                                            </li>
                                            <li className="facebook-share left" onClick={(e) => actions.shareArticle('facebook', "")}>
                                                <span className="M16_61 social-share" id="facebook">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                                                </span>
                                            </li>
                                            <li className="twitter-share left" onClick={(e) => actions.shareArticle('twitter', "")}>
                                                <span className="M16_61 social-share" id="twitter">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                                                </span>
                                            </li>
                                            <li className="twitter-share left" onClick={(e) => actions.shareArticle('pintrest', "")}>
                                                <span className="M16_61 social-share" id="pintrest">
                                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="detailIngredients">
                            <div className="intblock1">
                                <div className="ingIconImg left">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Ingredients-icon.png" />
                                </div>
                                <span className="ingradText M15_21 left">Ingredients</span>
                            </div>
                            <div className="Int-rec-block">
                                <div className="int-slidblock" id="int-slidblock1">
                                    <div className="int-slidup" id="int-slidup1">
                                        {/* <span className="slidicon" data-icon-font="%"></span> */}
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Prep (Clock).svg" className="slidicon" />
                                        <span className="slidtext M14_FF">Prep</span>
                                    </div>
                                    <div className="sliddown">
                                        <span className="M16_42">{this.state.prepTime}</span>
                                    </div>
                                </div>
                                <div className="int-slidblock" id="int-slidblock2">
                                    <div className="int-slidup" id="int-slidup2">
                                        {/* <span className="slidicon" data-icon-font="&#xe045;"></span> */}
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Cook.svg" className="slidicon" />
                                        <span className="slidtext M14_FF">Cook</span>
                                    </div>
                                    <div className="sliddown">
                                        <span className="M16_42">{this.state.cookTime}</span>
                                    </div>
                                </div>
                                <div className="int-slidblock" id="int-slidblock3">
                                    <div className="int-slidup" id="int-slidup3">
                                        {/* <span className="slidicon" data-icon-font="%"></span> */}
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Total.svg" className="slidicon" />
                                        <span className="slidtext M14_FF">Total</span>
                                    </div>
                                    <div className="sliddown">
                                        <span className="M16_42">{this.state.totalTime}</span>
                                    </div>
                                </div>
                            </div>
                            {this.state.ingredientsArr && this.state.ingredientsArr.length > 0 && this.state.ingredientsArr.map((ingredient, index1) =>
                                <div key={index1} className="veggidiv">
                                    <div className="circleInt left" onClick={() => { actions.addIngrediants(ingredient.id, ingredient.isChecked, ingredient.ingredient, "RL", this, this.state.recipeId, this.state.isApp, this.state.recipeDetailData.recName) }}>
                                        {/* <span className="circleIcon" data-icon-font={ingredient.isChecked == 1 ? "<" : "8"}></span> */}
                                        <div className="circleIcon">
                                        {ingredient.isChecked == "1" || ingredient.isChecked == 1 ?
                                            <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/check-mark-icon.png"/>
                                            :
                                            <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Plus-Icon.png"/>
                                        }
                                        </div>
                                    </div>
                                    <div className="veggitext R14_61 left">{ingredient.ingredient}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="directionBlock">
                            <div className="intblock1">
                                <div className="ingIconImg left">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Directions-to-Prepare-icon.png" />
                                </div>
                                <span className="ingradText M15_21 left">Direction to Prepare</span>
                            </div>
                            <div className="conline">
                                {this.state.preparedArr && this.state.preparedArr.length > 0 && this.state.preparedArr.map((Prepare, index) =>
                                    <div key={index} className="veggidiv" id={"veggidiv_" + index}>
                                        <div className="circleInt left">
                                            <span className={index + 1 > 9 ? "circleIcon numseries greaternum R14_red" : "circleIcon numseries R14_red"}>{index + 1}</span>
                                        </div>
                                        <div className="veggitext R14_61 left">{Prepare}</div>
                                    </div>
                                )}
                                <span className="connecting-line"></span>
                            </div>
                        </div>
                        <div className="tipBlock">
                            <div className="intblock1">
                                <div className="ingIconImg left">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/tips.png" />
                                </div>

                                <span className="ingradText R14_61 left"> <span className="ingradText_title left M14_42">Tips: </span>{this.state.recipeDetailData.tips}</span>
                            </div>
                        </div>
                        <div className="nutrifactBlock">
                            <div className="nutrititle M15_21">Nutritional Facts</div>
                            <div className="chartparent">
                                <div className="chart-container">
                                    <canvas id="myChart" width="400" height="400"></canvas>
                                </div>
                                <div className="caldiv">
                                    {this.state.recipeDetailData && this.state.recipeDetailData.totalCalories &&
                                        <div className="calories M20_purpal">{this.state.recipeDetailData.totalCalories.replace("calories", "kCal")}</div>
                                    }
                                </div>
                            </div>
                            <div className="chartvalue more" data-id={`chart_${this.state.recipeDetailData.recId}`} id={`chart_${this.state.recipeDetailData.recId}`}>
                                {this.state.nutrionalItems && this.state.nutrionalItems.length > 0 && this.state.nutrionalItems.map((items, index4) =>
                                    <div key={index4} className="cval left">
                                        <span className="colorblc blue" style={{ background: this.state.nutriFactsColorArr[index4] }}></span>
                                        <span className="cvaltitle M12_21">{this.state.nutrionalFacts[items]} {items && items.charAt(0).toUpperCase() + items.substr(1).toLowerCase()}</span>
                                    </div>
                                )}
                            </div>
                            {this.state.nutriFactColors && Object.entries(this.state.nutriFactColors).length > 6 &&
                                <div className="viewAllVal" onClick={(e) => actions.seeMoreClick(e, '45px', "detailsPage", this.state.isApp)}>
                                    <span className="valtxt">View All</span>
                                    <span data-icon-font="f" className="icon dwnIcon"></span>
                                </div>
                            }
                        </div>
                        <div className="healthBenBlock">
                            <div className="nutrititle M15_21">Health Benefits</div>
                            <div className="R14_61 healthDesc">
                                <span>{this.state.recipeDetailData.healthBenefit}</span>
                            </div>
                            <div className="R13_link" onClick={(e) => actions.seeMoreClick(e, '40px', "detailsPageHealth", this.state.isApp)} id="dev_rcpdtl_hlth_mr">See More</div>
                        </div>
                        <div className="buyingguidBlock">
                            <div className="nutrititle M15_21">Buying Guide</div>
                            <div className="R14_61 healthDesc">
                                <span>{this.state.recipeDetailData.buyingGuid}</span>
                            </div>
                            {this.state.recipeDetailData.buyingGuid &&
                                <div className="R13_link" onClick={(e) => actions.seeMoreClick(e, '40px', "detailsPageGuide", this.state.isApp)} id="dev_rcpdtl_by_mr">See More</div>
                            }
                        </div>
                        {/* {this.state.reviewDataDetails && */}
                        <div className="imadeitBlock">
                            <div className="intblock1">
                                <div className="ingIconImg left">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/i-made-it-icon.png" />
                                </div>
                                <span className="ingradText M15_21 left">Mom’s Made It</span>
                                <span className="madecnt M12_9e">({this.state.reviewDetails.userUploadedImgCount})</span>
                            </div>
                            <div className="slider-cont-meal">
                                <div className="madeSliderBlock">
                                    <ul>
                                        {this.state.reviewDetails && this.state.reviewDetails.userImageArr && this.state.reviewDetails.userImageArr.length > 0 && this.state.reviewDetails.userImageArr.map((momMadeIt, index3) =>
                                            <div key={index3}>
                                                {momMadeIt.uploadedRecUrl &&
                                                    <li className="left">
                                                        <div className="made-food-img" onClick={() => { this.onrecipeClickGA() }}>
                                                            <img src={momMadeIt.uploadedRecUrl.replace("http://", "https://")} onError={(e) => (e.target.src = momMadeIt.uploadedRecUrl.replace("http://", "https://"))} name={this.state.recipeName + " for Babies & Toddlers.jpg"} alt={this.state.recipeName + " for Babies & Toddlers.jpg"} title={this.state.recipeName + " for Babies & Toddlers.jpg"} className="dev_mom_md_it" />

                                                            {/* <img src={madeIt.uploadedRecUrl} /> */}
                                                            {/* <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/i-made-it-img-1.jpg" /> */}
                                                        </div>
                                                        <div className="madeuserblk">
                                                            <div className="userimg left">
                                                                <img src={momMadeIt.userphoto} onError={(e) => (e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Peanuts-free.jpg")} />
                                                            </div>
                                                            <div className="userinfo left">
                                                                <div className="username R13_42">{momMadeIt.firstname}</div>
                                                                <div className="userdesc R13_42">{momMadeIt.childkey}</div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                }
                                            </div>
                                        )}
                                    </ul>
                                    {this.state.windowWidth > 767 && this.state.reviewDataDetails.length > 3 ?
                                        <div className="arrows">
                                            <span className="next" onClick={(e) => { actions.slideStage(e, this, 'madeSliderBlock') }}>
                                                <span data-icon-font="h" className="icon dev_next"></span>
                                            </span>
                                            <span className="prev" onClick={(e) => { actions.slideStage(e, this, 'madeSliderBlock') }}>
                                                <span data-icon-font="g" className="icon dev_prev"></span>
                                            </span>
                                        </div>
                                        :
                                        <div className="arrows">
                                            <span className="next" onClick={(e) => { actions.slideStage(e, this, 'madeSliderBlock') }}>
                                                <span data-icon-font="h" className="icon dev_next"></span>
                                            </span>
                                            <span className="prev" onClick={(e) => { actions.slideStage(e, this, 'madeSliderBlock') }}>
                                                <span data-icon-font="g" className="icon dev_prev"></span>
                                            </span>
                                        </div>
                                    }
                                    <input type="hidden" id="pgNo" value="" />
                                </div>
                            </div>
                        </div>
                        {/* } */}
                        <div className="ratreviewBlock">
                            <div className="titlerate">
                                <div className="left M15_21"> Rating & Reviews</div>
                                <div className="ratbtnn right" onClick={() => { this.rateRecipe() }}>
                                    <div className="ratstarimg left">
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/recipe-btn-star.png" />
                                    </div>
                                    <div className="ratbtntext M11_FF">Rate Recipe</div>
                                </div>
                                <div className="ratedblock right" style={{ display: 'none' }}>
                                    <div className="rimg left">
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/big-star.png" />
                                    </div>
                                    <div className="B30_42 percent1 left">20%</div>
                                    <div className="R12_9e urrateing">Your Rating</div>
                                </div>
                            </div>
                            <div className="ratelinescon">
                                <div className="rateblk1">
                                    <div className="rbigstarimg">
                                        <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/big-star.png" />
                                        <span className="ratcnt M12_FF">{this.state.reviewDetails.ratingpercentcount}</span>
                                    </div>
                                    <div className="R12_61 rstartext">{this.state.reviewDetails.totalUserRatingCount}  rating and {this.state.reviewDetails.reviewCount} reviews</div>
                                </div>
                                <div className="rateblk2">
                                    {this.state.ratingAllDetails && this.state.ratingAllDetails['msg'] != -1 && this.state.ratingDetails && this.state.ratingDetails.length > 0 && this.state.ratingDetails.map((ratingDetails, index2) =>
                                        <div key={index2} className="ratline">
                                            <div className="rarval M10_42">{5 - index2}</div>
                                            <div className="greystar"><img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/small-star.png" /></div>
                                            <div className="rline" id={"rline_" + (5 - index2)}>
                                                <div className="filled rate5" data-id={ratingDetails} id={"rline_" + (5 - index2)} style={{ width: ratingDetails + "%" }}></div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {this.state.reviewDataDetails && this.state.reviewDataDetails != '' &&
                                <div className="seeallreviewbt" onClick={() => { this.allReviews() }}>
                                    <span className="M13_FF dev_rev_scrn">See All Reviews</span>
                                </div>
                            }
                        </div>
                        <FooterMenu eleRef={this} flag="RDL" isApp={this.state.isApp} />
                    </div>
                    <div className="raterecipe-overlay">
                        <div className="ratePopup">
                            <div className="parrate">
                                <div className="scrollblock">
                                    <div className="overScrollPic">
                                        <div className="rimgback"></div>
                                        <div className="popchildimg">
                                            <img src={this.state.childPhoto ? this.state.childPhoto : 'https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Display Picture.png'} className="starRateImg" onError={(e) => (e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Display Picture.png")} />
                                        </div>
                                        <div className="ratetitle M18_42">rate the recipe</div>
                                        <div className="percent B30_42">0%</div>
                                        <div className="like R12_61" id="likeit"> Liked It</div>
                                        <div className="stardiv">
                                            <div className="ratestar ratingstar" onClick={(e) => { this.rating(e, "1") }}>
                                                <img className="ratImg" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/rating-star.png" />
                                            </div>
                                            <div className="ratestar ratingstar" onClick={(e) => { this.rating(e, "2") }}>
                                                <img className="ratImg" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/rating-star.png" />
                                            </div>
                                            <div className="ratestar ratingstar" onClick={(e) => { this.rating(e, "3") }}>
                                                <img className="ratImg" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/rating-star.png" />
                                            </div>
                                            <div className="ratestar ratingstar" onClick={(e) => { this.rating(e, "4") }}>
                                                <img className="ratImg" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/rating-star.png" />
                                            </div>
                                            <div className="ratestar" onClick={(e) => { this.rating(e, "5") }}>
                                                <img className="ratImg" src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/rating-star.png" />
                                            </div>
                                        </div>
                                        <span id="errratesubmit"></span>
                                        <div className="hrline"></div>
                                        <div className="writereview R16_link"> Write a Review</div>
                                        <div className="optional R12_61"> (Its Optional)</div>
                                        <div className="reviewtitle">
                                            <input className="R14_42 reviewTitle" id="reviewTitle" maxLength="100" value={this.state.textValue} type="text" placeholder="Review Title" onChange={this.handleChangecmnt1.bind(this)} />
                                            <span className="maxLength-feedback" id="maxLengthcmmt" style={{ display: 'none' }}></span>
                                            <div className="hrline1"></div>
                                        </div>
                                        <div className="desctitle">
                                            <textarea className="R14_bd descTitle" id="descTitle" minLength="10" maxLength="250" rows="1" value={this.state.textValue1} placeholder="Description" onChange={this.handleChangecmnt2.bind(this)} />
                                            <span className="maxLength-feedback" id="maxLengthcmmt" style={{ display: 'none' }}></span>
                                            <div className="hrline2"></div>
                                        </div>
                                        <div className="minchar R12_9e">Minimum 200 characters</div>
                                        {/* <span id="errratecharsubmit" className="left"></span> */}
                                        <div className="picupload" onClick={() => { this.onCameraSelect() }}>
                                            <span className="cameraicon" data-icon-font="x"></span>
                                            <span className="addphoto R14_42"> Add Recipe Image</span>
                                        </div>
                                        <div className="pictureblck">
                                            <div className="picdiv left">
                                                <div className="ratestar">
                                                    <img className="recipePhoto" src="" />
                                                </div>
                                                <div className="closepic" onClick={() => { this.oncloseCamera() }}><span className="closepicicon left" data-icon-font="C"></span>
                                                </div>
                                            </div>
                                            <div className="checkdiv">
                                                {this.state.tncAgree ?
                                                    <span className="icon check left isChecked" data-icon-font="A" name="check" onClick={() => this.checkTnc()}></span>
                                                    :
                                                    <span className="icon check left" data-icon-font="z" name="check" onClick={() => this.checkTnc()}></span>
                                                }
                                                {/* <input className="checkbox left" type="checkbox" name="check" defaultChecked={this.state.tncAgree} onChange={() => this.checkTnc()} /> */}

                                            </div>
                                            <div className="agreediv">
                                                <span className="agree R12_42">I agree to post photo on recipe page.</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="reviewsubmit" onClick={() => { this.onSubmitrecipe() }}>
                                        <span className="M15_FF dev_submit"> Submit </span>
                                    </div>
                                    {/* <div className="closeReviewPop" onClick={() => { this.onclosePopup() }}><span className="closepicicon left" data-icon-font="C"></span>
                                    </div> */}
                                </div>
                            </div>
                            <div className="closeReviewPop" onClick={() => { this.onclosePopup() }}><span className="closepicicon left" data-icon-font="C"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="share-overlay"></div>
                <div className="new-right-sect">
                    <Right url={this.props.location.pathname} />
                </div>
            </main>
        )
    }
}

export default withContext(Recipedetails);
